// Конструктор


import {throttle} from "../modules/Util";

if (App.H.is('.page-constructor')) {

    $('.js-c-header-nav').each(function () {
        let $nav = $(this);
        let $navs = $('.js-c-header-nav-list-item', $nav);
        let $menus = $('.js-c-header-nav-menu', $nav);

        $navs.each(function (i, el) {
            $(el).on('mouseenter', function () {

                $menus
                    .removeClass('_active')
                    .eq(i)
                    .addClass('_active');

                $navs
                    .removeClass('_hovered')
                    .eq(i)
                    .addClass('_hovered');
            });
        });

        $nav.on('mouseleave', function () {
            $menus.removeClass('_active');
            $navs.removeClass('_hovered');
        });
    });

    $('.js-c-footer-nav').each(function () {
        const $root = $(this);
        const $toggler = $('[data-nav-toggler]', this);
        const $content = $('[data-nav-content]', this);

        $toggler.on('click', function () {
            $content.slideToggle();
            $root.toggleClass('__opened');
        });
    });

    App.D.ready(function () {
        $('.js-c-stada-group').addClass('shown');
    });

    /* Показываем кнопку обратной связи, спустя 2 секунды после загрузки страницы */
    setTimeout(() => {
        App.H.addClass('_feedback-showen');
    }, 2000);

    // App.W.on('scroll', throttle(showFeedbackBtn, 200));
}


/* Показываем кнопку обратной связи, если просролили дальше первого экрана */
// function showFeedbackBtn() {
//     const scrollTop = App.W.scrollTop();

//     if (scrollTop > App.W.outerHeight() / 2) {
//         App.H.addClass('_feedback-showen');
//     } else {
//         App.H.removeClass('_feedback-showen');
//     }
// }

